import { EmailType } from '../common/enums/EmailType';
import api from '../common/helpers/apiHelper';
import { IEmailTemplate } from '../common/models/email/IEmailTemplate';

export const getUserEmailTemplates = () => api.get(
  '/api/email-templates/'
);

export const getEmailTemplate = (type: EmailType) => api.get(
  `/api/email-templates/type/${type}`
);

export const getRefReqTemplates = () => api.get('/api/email-templates/ref-req');

export const createEmailTemplate = (emailTemplate: IEmailTemplate) => api.post(
  '/api/email-templates/',
  emailTemplate
);

export const updateEmailTemplate = (emailTemplate: IEmailTemplate) => api.put(
  '/api/email-templates/',
  emailTemplate
);

export const getCandidateTemplateCode = () => api.get<{ code: string }>(
  '/api/email-templates/candidate-code'
);

export const getReferenceTemplateCode = () => api.get<{ code: string }>(
  '/api/email-templates/reference-code'
);
